import { readStoredPlayerAssignment } from './playerSessionStorage';

export const API = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';
export const API_ROOT = API.replace(/\/api$/, '');
const ADMIN_UNAUTHORIZED_EVENT = 'admin:unauthorized';

function emitAdminUnauthorized() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(ADMIN_UNAUTHORIZED_EVENT));
  }
}

async function request(path, options = {}) {
  const { playerAuth = false, ...restOptions } = options;
  const headers = { 'Content-Type': 'application/json', ...(restOptions.headers || {}) };
  if (playerAuth) {
    const assignment = readStoredPlayerAssignment();
    if (assignment?.playerToken) {
      headers.Authorization = `Bearer ${assignment.playerToken}`;
    }
  }

  const response = await fetch(`${API}${path}`, {
    credentials: 'include',
    ...restOptions,
    headers
  });

  if (response.status === 204) return null;
  const data = await response.json();
  if (!response.ok) {
    if (response.status === 401 && path.startsWith('/admin')) {
      emitAdminUnauthorized();
    }
    const error = new Error(data.message || data.error || 'API greška.');
    error.code = data.code || null;
    error.status = response.status;
    throw error;
  }
  return data;
}

export const apiClient = {
  getSessionStatus: () => request('/session/status'),
  getSessionMe: () => request('/session/me', { playerAuth: true }),
  joinSession: (name) => request('/session/join', { method: 'POST', body: JSON.stringify({ name }) }),

  submitAnswer: (body) => request('/game/answer', { method: 'POST', body: JSON.stringify(body), playerAuth: true }),
  unlockRound: (secretWord) => request('/game/unlock', { method: 'POST', body: JSON.stringify({ secretWord }), playerAuth: true }),
  startGame: () => request('/game/start', { method: 'POST' }),
  resetGame: () => request('/game/reset', { method: 'POST' }),
  stopGame: () => request('/game/stop', { method: 'POST' }),

  adminLogin: (username, password) => request('/admin/login', { method: 'POST', body: JSON.stringify({ username, password }) }),
  adminLogout: () => request('/admin/logout', { method: 'POST' }),
  getAdminMe: () => request('/admin/me'),

  getAdminBootstrap: () => request('/admin/bootstrap'),
  getAdminGameStatus: () => request('/admin/game-status'),
  getAdminGameLog: () => request('/admin/game-log'),
  updateDraftQuiz: (body) => request('/admin/draft-quiz', { method: 'PUT', body: JSON.stringify(body) }),
  getQuestionSets: () => request('/admin/question-sets'),
  getQuestionSet: (id) => request(`/admin/question-sets/${id}`),
  createQuestionSet: (body) => request('/admin/question-sets', { method: 'POST', body: JSON.stringify(body) }),
  updateQuestionSet: (id, body) => request(`/admin/question-sets/${id}`, { method: 'PUT', body: JSON.stringify(body) }),
  deleteQuestionSet: (id) => request(`/admin/question-sets/${id}`, { method: 'DELETE' }),
  createQuestion: (setId, body) => request(`/admin/question-sets/${setId}/questions`, { method: 'POST', body: JSON.stringify(body) }),
  updateQuestion: (setId, questionId, body) => request(`/admin/question-sets/${setId}/questions/${questionId}`, { method: 'PUT', body: JSON.stringify(body) }),
  deleteQuestion: (setId, questionId) => request(`/admin/question-sets/${setId}/questions/${questionId}`, { method: 'DELETE' }),
  getQuizzes: () => request('/admin/quizzes'),
  saveQuiz: (body) => request('/admin/quizzes', { method: 'POST', body: JSON.stringify(body) }),
  updateQuiz: (id, body) => request(`/admin/quizzes/${id}`, { method: 'PUT', body: JSON.stringify(body) }),
  loadQuizToDraft: (id) => request(`/admin/quizzes/${id}/load`, { method: 'POST' }),
  deleteQuiz: (id) => request(`/admin/quizzes/${id}`, { method: 'DELETE' }),
  getGlobalSettings: () => request('/admin/global-settings'),
  uploadGlobalAsset: (slot, body) => request(`/admin/global-settings/assets/${slot}`, { method: 'POST', body: JSON.stringify(body) }),
  deleteGlobalAsset: (slot) => request(`/admin/global-settings/assets/${slot}`, { method: 'DELETE' })
};

export { ADMIN_UNAUTHORIZED_EVENT };
